import { Close } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, Modal, styled } from '@mui/material';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMessage } from '../../../../base/MessageProvider';
import { otpLogin } from '../../../actions/auth';
import { replaceCountryCode } from '../../../../utils';
import { Bars } from 'react-loader-spinner';
import clsx from 'clsx';

const boxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    width: '90%',
    bgcolor: 'white',
    paddingX: 5,
    paddingY: 3,
    borderRadius: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center' 
}

const CustomBorderTextField = styled(MuiTelInput)`
    & .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
            border-color: #3A3A3A;
        }
        & img {
            max-width: 75%;
        }
    }
`;

const LoginModal = ({ open, onClose }) => {
    const [phone, setPhone] = useState('');
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const alert = useMessage();

    const loading = useSelector((state) => state.artistAuthReducer?.loading);

    const handleChange = (newPhone) => {
        setPhone(newPhone);
    }

    const onClickSignup = () => {
        navigate('/artist/auth/signup');
    }

    const onSubmit = async (e) => {
        e?.preventDefault?.();
        setErrorMessage("");
        if (!matchIsValidTel(phone)) {
            setErrorMessage("Invalid mobile number!!");
            return;
        }
        const mobileNo = replaceCountryCode(phone);
        dispatch(otpLogin({ mobileNo }, (loginOtp) => {
            navigate('/artist/auth/login-otp', { replace: false });
            alert.showInfo(loginOtp, { timeout: 5000 });
        }, (error) => {
            setErrorMessage(error?.message ?? "Something went wrong!!");
        }))
    }

    return (
        <Modal disableAutoFocus sx={{ bgcolor: '#F4F4F499'}} hideBackdrop open={open}>
            <form onSubmit={onSubmit} action="#">
                <Box className="shadow-[0_0_14px_grey]" sx={boxStyle}>
                    <IconButton onClick={onClose} className='absolute top-3 right-3' size='small'> 
                        <Close className='text-xl' />
                    </IconButton>
                    <Box className="mb-4">
                        <h2 className="font-['Poppins-Medium'] font-[500] text-[16px]">LOG IN</h2>
                    </Box>
                    <div className="flex flex-col gap-3 mt-3">
                        <CustomBorderTextField size='small' InputProps={{ className: 'rounded-full' }} defaultCountry="IN" disableFormatting 
                            disableDropdown forceCallingCode value={phone} onChange={handleChange} />
                    </div>
                    {errorMessage && (
                        <div className="flex my-1 ml-2 w-full">
                            <div className="text-[14px] text-red-600">{errorMessage}</div>
                        </div>
                    )}
                    <Button onClick={onSubmit} disabled={loading} className={clsx("bg-[#2F80ED] flex gap-3 justify-center text-[#FFF] w-full rounded-full my-3 font-['Poppins-Medium'] font-[500]", { "bg-opacity-70": loading })}>
                        Log In
                        <Bars
                            height="20"
                            width={'20'}
                            color="#FFFFFF"
                            ariaLabel="bars-loading"
                            visible={loading}
                        />
                    </Button>
                    <p className="font-['Matter-Regular'] font-[400] text-[12px] text-center text-[#1F1E1E]">
                        Don't Have An Account? <a onClick={onClickSignup} className="text-[#2F80ED] hover:underline cursor-pointer">Sign Up</a>
                    </p>
                </Box>
            </form>
        </Modal>
    );
}

export default React.memo(LoginModal, (prevProps, nextProps) => {
    return prevProps.open === nextProps.open
});